import { getLang } from '../utils/helpers.js';

require('../utils/forms.js');

var $feedbackForm = $('.js-feedback-form'),
    $questionForm = $('.js-question-form'),
    $contentFeedbackForm = $('.js-popup-content-feedback-form'),
    $popupFeedbackForm = $('.popup_feedback'),
    $popupQuestionForm = $('.popup_question'),
    $popupContentFeedbackForm = $('.popup_content-feedback'),
    $popupFeedbackMessage = $('.popup_feedback-message');

var validator = $feedbackForm.validate({
    lang: getLang(),
    debug: false,
    errorClass: 'form-error',
    errorElement: 'span',
    ignore: '',
    rules: {
      name: {
        required: true,
      },
      email: {
        required: true,
        email: true,
      },
      phone: {
        required: true,
        phone: true,
        normalizer: function(value){
          return value.replace(/[\s\-\(\)]/g, '');
        },
      },
    },
    errorPlacement: function (error, element) {
        if($(element).is(':radio')) {
            $(element).parent().parent().prev().append(error);
        } else {
            $(element).prev().append(error);
        }
    },
    highlight: function(element) {
        if($(element).is(':radio')) {
            $(element).parent().parent().prev().addClass('_error');
        } else {
            $(element).addClass('_error');
            $(element).prev().addClass('_error');
        }
        
        
    },
    unhighlight: function(element) {
        if($(element).is(':radio')) {
            $(element).parent().parent().prev().removeClass('_error');
        } else {
            $(element).removeClass('_error');
            $(element).prev().removeClass('_error');
        }
    }
});

var questionFormValidator = $questionForm.validate({
    lang: getLang(),
    debug: false,
    errorClass: 'form-error',
    errorElement: 'span',
    ignore: '',
    rules: {
      name: {
        required: true,
      },
      email: {
        required: true,
        email: true,
      },
      phone: {
        required: true,
        phone: true,
        normalizer: function(value){
          return value.replace(/[\s\-\(\)]/g, '');
        },
      },
    },
    errorPlacement: function (error, element) {
        if($(element).is(':radio')) {
            $(element).parent().parent().prev().append(error);
        } else {
            $(element).prev().append(error);
        }
    },
    highlight: function(element) {
        if($(element).is(':radio')) {
            $(element).parent().parent().prev().addClass('_error');
        } else {
            $(element).addClass('_error');
            $(element).prev().addClass('_error');
        }
        
        
    },
    unhighlight: function(element) {
        if($(element).is(':radio')) {
            $(element).parent().parent().prev().removeClass('_error');
        } else {
            $(element).removeClass('_error');
            $(element).prev().removeClass('_error');
        }
    }
});

var contentFormValidator = $contentFeedbackForm.validate({
    lang: getLang(),
    debug: false,
    errorClass: 'form-error',
    errorElement: 'span',
    ignore: '',
    rules: {
      name: {
        required: true,
      },
      email: {
        required: true,
        email: true,
      },
      phone: {
        required: true,
        phone: true,
        normalizer: function(value){
          return value.replace(/[\s\-\(\)]/g, '');
        },
      },
    },
    errorPlacement: function (error, element) {
        if($(element).is(':radio')) {
            $(element).parent().parent().prev().append(error);
        } else {
            $(element).prev().append(error);
        }
    },
    highlight: function(element) {
        if($(element).is(':radio')) {
            $(element).parent().parent().prev().addClass('_error');
        } else {
            $(element).addClass('_error');
            $(element).prev().addClass('_error');
        }
        
        
    },
    unhighlight: function(element) {
        if($(element).is(':radio')) {
            $(element).parent().parent().prev().removeClass('_error');
        } else {
            $(element).removeClass('_error');
            $(element).prev().removeClass('_error');
        }
    }
});

$feedbackForm.submit(function(e){
    let $feedbackForm = $(this);
    if(validator.valid()){
        $.post(
          $feedbackForm.attr('action'),
          $feedbackForm.serialize(),
          function(data){
            if (data.error != true){
                $('.feedback-modal').show();
                $('.modal-cnt').fadeIn();
                $feedbackForm[0].reset();
                validator.reset();
                $popupFeedbackForm.fadeOut(500);
                $popupFeedbackMessage.fadeIn(500);
                $(window).scrollTop(0);
            }
          }
        );
    }
    return false;
});

$questionForm.submit(function(e){
    let $questionForm = $(this);
    if(validator.valid()){
        $.post(
          $questionForm.attr('action'),
          $questionForm.serialize(),
          function(data){
            if (data.error != true){
                $('.feedback-modal').show();
                $('.modal-cnt').fadeIn();
                $questionForm[0].reset();
                validator.reset();
                $popupQuestionForm.fadeOut(500);
                $popupFeedbackMessage.fadeIn(500);
                $(window).scrollTop(0);
            }
          }
        );
    }
    return false;
});

$contentFeedbackForm.submit(function(e){
    let $contentFeedbackForm = $(this);
    if(contentFormValidator.valid()){
        $.post(
          $contentFeedbackForm.attr('action'),
          $contentFeedbackForm.serialize(),
          function(data){
            if (data.error != true){
                $('.feedback-modal').show();
                $('.modal-cnt').fadeIn();
                $contentFeedbackForm[0].reset();
                contentFormValidator.reset();
                $popupContentFeedbackForm.fadeOut(500);
                $popupFeedbackMessage.fadeIn(500);
                $(window).scrollTop(0);
            }
          }
        );
    }
    return false;
});



// WEBPACK FOOTER //
// ./js/pages/common.js